import React, { useEffect, useState } from 'react'
import { Switch, FormControlLabel } from '@material-ui/core'

function ConfiguracionWSCTG (props) {
  const { estadoWSCTG, updateWSCTG } = props
  const [estado, setEstado] = useState(estadoWSCTG)

  useEffect(() => {
    setEstado(estadoWSCTG)
  }, [estadoWSCTG, setEstado])

  const updateCTGPostergada = () => {
    if (estadoWSCTG === 1) {
      updateWSCTG(0)
      setEstado(0)
    } else {
      updateWSCTG(1)
      setEstado(1)
    }
  }

  return (
    <>
      <h5>Configuración web service ARCA</h5>
      <FormControlLabel
        control={<Switch
          color='primary'
          name='ctgpostergada'
          onChange={updateCTGPostergada}
          checked={estado === 1}
        />
        }
        label='Validación de CTG postergada'
      />
    </>
  )
}

export default ConfiguracionWSCTG
